var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"col-md-9 ms-sm-auto col-lg-10 px-md-4"},[_vm._t("default",function(){return [_vm._v("欢迎光临")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }